import styled from 'styled-components';
import { Form } from '@ui';

export const FormSC = styled(Form)`
  .ui-textfield,
  .date-row {
    width: 100%;
  }
` as typeof Form;
